function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Email marketing automation and anlysis is among the best ways to reach out your subscribers and potential customers.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox enables advanced email marketing automation, based on past interactions and behavioral user information, we call labels. WhiteBox detects whether an email has been delivered, seen or opened.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/email","interaction":"email","title":"(Email)|marketing","image":"/img/interactions/4.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }